import { configureStore } from '@reduxjs/toolkit'
import logger from 'redux-logger'
import { persistReducer } from 'redux-persist'
import createSagaMiddleware from 'redux-saga'
import storage from 'redux-persist/lib/storage'  // defaults to localStorage for web
import rootReducer from '../reducers/rootReducer'
import rootSaga from '../sagas/rootSaga'
import SetTransform from './transform'

const sagaMiddleware = createSagaMiddleware()

const persistConfig = {
  key: 'root',
  storage,
  transforms: [SetTransform],
  whitelist: ['auth']
}

let middleware: any[] = [sagaMiddleware];

if (process.env.NODE_ENV === 'development') {
  middleware = [logger, sagaMiddleware];
}

const persistedReducer = persistReducer(persistConfig, rootReducer) as typeof rootReducer

export const store = configureStore({
  reducer: persistedReducer,
  middleware: middleware,
})

sagaMiddleware.run(rootSaga)

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch